import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColumnApi, DomLayoutType, FilterChangedEvent, FirstDataRenderedEvent, GridApi, GridOptions, GridReadyEvent, GridSizeChangedEvent, ITooltipParams, SortChangedEvent } from 'ag-grid-community';
import { RegStatusRendererComponent } from '../../cell-renderers/reg-status-renderer/reg-status-renderer.component';
import { PaginationPageSizes, PartnerListGridHeaderNames, StorageKeyNamesManage } from 'src/app/constants';
import { StorageService } from 'src/app/shared/services/storage.service';
import { SharedService } from 'src/app/shared/shared.service';
import { PartnerActionRendererComponent } from '../../cell-renderers/partner-action-renderer/partner-action-renderer.component';

@Component({
  selector: 'app-partner-list',
  templateUrl: './partner-list.component.html',
  styleUrls: ['./partner-list.component.scss']
})
export class PartnerListComponent implements OnInit, OnChanges {

  @Input() rowData: any;

  @Input() tableConfigOptions: any;

  @Input() isStoreParams: boolean;

  @Input() formSide: string;

  @Input() fromComponent: string;

  @Input() sectionName: string;

  idString = '';

  gridApi: GridApi;

  gridColumnApi: ColumnApi;

  public frameworkComponents: any;

  @Output() rowSelectedEvent = new EventEmitter();

  @Output() rowEditedEvent = new EventEmitter();

  gridOptions: GridOptions;

  rowSelection: "single" | "multiple" = "single";

  selectedRows: any;

  public columnDefs: ColDef[];

  public defaultColDef: ColDef = {
    sortable: true,
    cellDataType: false,
    flex: 1,
    minWidth: 150
  };

  public paginationPageSize = 10;

  public domLayout: DomLayoutType;

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  style: any = {
    width: '100%',
    height: '100%'
  };

  col_api_endpoint: boolean;

  col_portal_url: boolean;

  paginationPageSizes = PaginationPageSizes;

  storedParams: any = {
    filterModel: {},
    sortModel: [],
    searchText: ''
  }

  constructor(private storageService: StorageService, private sharedService: SharedService) { }

  ngOnInit(): void {
    this.idString = this.sharedService.createIdString(this.fromComponent, this.sectionName, 'partnersGrid');
    this.columnDefs = [
      {
        flex: 1,
        width: 170,
        headerName: PartnerListGridHeaderNames.name,
        field: 'partner_name',
      },
      {
        flex: 1,
        headerName: PartnerListGridHeaderNames.shortName,
        field: 'short_name',
        width: 150
      },
      // {
      //   flex: 1,
      //   headerName: PartnerListGridHeaderNames.description,
      //   field: 'description',
      //   width: 120
      // },
      {
        flex: 1,
        headerName: PartnerListGridHeaderNames.apiEndpoint,
        field: 'api_endpoint',
        tooltipValueGetter: (params: ITooltipParams) => {
          return params.data.api_endpoint;
        }
      },
      {
        flex: 1,
        headerName: PartnerListGridHeaderNames.portalUrl,
        field: 'portal_url',
        tooltipValueGetter: (params: ITooltipParams) => {
          return params.data.portal_url;
        }
      },
      {
        flex: 1,
        width: 170,
        headerName: PartnerListGridHeaderNames.regStatus,
        field: 'registration_status',
        cellRenderer: 'regStatusRenderer',
        headerClass: 'header-label-center',
        tooltipValueGetter: (params: ITooltipParams) => {
          let status = '';
          if (params.data.registration_status === 'PENDING') {
            status = 'Registration Pending'
          } else {
            status = 'Registration Complete'
          }
          return status;
        }
      },
      {
        flex: 1,
        width: 120,
        headerName: PartnerListGridHeaderNames.accessLevel,
        field: 'app_access_level'
      },
      {
        flex: 1,
        width: 120,
        headerName: PartnerListGridHeaderNames.action,
        cellRenderer: 'partnerActionRenderer',
        headerClass: 'header-label-center'
      }
    ];
    this.gridOptions = {
      sortingOrder: ['asc', 'desc'],
      pagination: true,
      suppressPaginationPanel: false,
      paginationPageSize: this.paginationPageSize,
      animateRows: true,
      context: { componentParent: this },
      onGridReady: ($event: any) => {
        this.onGridReady($event);
      },
      onFilterChanged: (e: FilterChangedEvent) => {
        this.storedParams.filterModel = e.api.getFilterModel();
        this.saveGridParams();
      },
      onSortChanged: (e: SortChangedEvent) => {
        this.storedParams.sortModel = e.columnApi.getColumnState();
        this.gridColumnApi.applyColumnState({
          state: this.storedParams.sortModel
        });
        this.saveGridParams();
      },
    }
    this.frameworkComponents = {
      regStatusRenderer: RegStatusRendererComponent,
      partnerActionRenderer: PartnerActionRendererComponent
    }
    this.operateTableConfigs();
  }

  operateTableConfigs() {
    this.domLayout = (this.tableConfigOptions && this.tableConfigOptions.domLayoutType) ? this.tableConfigOptions.domLayoutType : 'autoHeight';
    if (this.tableConfigOptions) {
      if (this.tableConfigOptions.columns && this.tableConfigOptions.columns.length)
        this.tableConfigOptions.columns.forEach((item: any) => {
          this.columnDefs.forEach(column => {
            if (item.headerName === column.headerName) {
              column.hide = item.hide;
            }
          });
        });
    }
  }

  checkStoredParams(storedParams: any) {
    this.gridApi.setFilterModel(storedParams.filterModel);
    this.gridApi.onFilterChanged();
    if (storedParams.sortModel.length) {
      this.gridColumnApi.applyColumnState({
        state: storedParams.sortModel
      });
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.hideOverlay();
    const storedParams = this.storageService.getGridParams(this.formSide, this.fromComponent, StorageKeyNamesManage.partnerList);
    const filterModelLength = (storedParams && storedParams.filterModel) ? Object.keys(storedParams.filterModel).length : 0;
    const sortModelLength = (storedParams && storedParams.sortModel) ? (storedParams.sortModel).length : 0;
    if (storedParams && (filterModelLength || sortModelLength)) {
      this.checkStoredParams(storedParams);
    }
    // params.api.sizeColumnsToFit();
    window.setTimeout(() => {
      params.api.sizeColumnsToFit();
    }, 1000);

  }

  saveGridParams() {
    if (this.isStoreParams) {
      this.storageService.saveGridParams(this.storedParams, this.formSide, this.fromComponent, StorageKeyNamesManage.partnerList);
    }
  }

  onRowSelected(event: any) {
    this.getSelectedRows();
  }

  getSelectedRows() {
    const selectedNodes = this.gridApi.getSelectedNodes();
    this.selectedRows = selectedNodes.map(node => node.data);
    this.rowSelectedEvent.emit(this.selectedRows);
  }

  onRowDoubleClicked(event: any) {
    const tempObj = {
      action: 'edit',
      data: event.data
    }
    this.rowEditedEvent.emit(tempObj);
  }

  onPageSizeChanged() {
    this.gridApi.paginationSetPageSize(Number(this.paginationPageSize));
  }

  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  handleActionClick(action: string, data: any) {
     const tempObj = {
      action: action,
      data: data
    }
    this.rowEditedEvent.emit(tempObj);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter(this.tableConfigOptions.searchText)
    } else if (!this.tableConfigOptions.searchText && this.gridApi) {
      this.gridApi.setQuickFilter('')
    }
  }

}
